import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './preview-info-dialog.component.html'
})
export class PreviewInfoDialogComponent implements OnInit {
  public returnInfo: string;
  public sendInfo: string;

  constructor(private matDialogRef: MatDialogRef<PreviewInfoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.returnInfo = data.return_info;
    this.sendInfo = data.send_info;
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('700px');
  }

  closeDialog() {
    this.matDialogRef.close(false);
  }
}
